module.exports = __webpack_public_path__ + "img/des5.93365f2a.png";